import { ProFormaGenericColumn } from 'views/ProFormaTable/components/ProFormaGenericTable/types';
import { PermanentDebtSizingMethod } from 'views/ProFormaTable/types';

export const DEBT_SERVICE_COLUMNS: ProFormaGenericColumn[] = [
    {
        key: 'title',
        field: 'title',
        header: '',
        format: 'none',
        isReadOnly: true,
    },
    {
        key: 'stabilizationValue',
        field: 'stabilizationValue',
        header: '% of stab. value',
        format: 'percentage',
        isReadOnly: true,
    },
    {
        key: 'costPercentage',
        field: 'costPercentage',
        header: '% of cost',
        format: 'percentage',
        isReadOnly: true,
    },
    {
        key: 'amount',
        field: 'amount',
        header: 'Amount',
        format: 'currency',
    },
    {
        key: 'annualPayment',
        field: 'annualPayment',
        header: 'Annual payment',
        format: 'currency',
        isReadOnly: true,
    },
];

export const TOTAL_DEBTSERVICE_COLUMNS: ProFormaGenericColumn[] = [
    {
        key: 'title',
        field: 'title',
        header: 'Cash flow after financing',
        format: 'none',
        isReadOnly: true,
    },
    {
        key: 'annualPayment',
        field: 'annualPayment',
        header: '',
        format: 'none',
        isReadOnly: true,
    },
];

export const formatDateWithMonthAndYear = (date: Date) => date.toLocaleString('en-US', { month: 'short', year: 'numeric' });

export const CALCULATION_METHOD_OPTIONS = [
    { label: 'Default', value: PermanentDebtSizingMethod.default },
    { label: 'DSCR', value: PermanentDebtSizingMethod.dscr },
    { label: 'Debt Yield', value: PermanentDebtSizingMethod.debt_yield },
    { label: 'LTV', value: PermanentDebtSizingMethod.ltv },
];
